import { render, staticRenderFns } from "./CityData.vue?vue&type=template&id=497cc607&"
import script from "./CityData.vue?vue&type=script&lang=js&"
export * from "./CityData.vue?vue&type=script&lang=js&"
import style0 from "./CityData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports